import { baseRequest } from '.'
import _get from 'lodash/get'

export const getSignedRequest = async filename => {
  const res = await baseRequest.post(`uploads`, {
    filename
  })
  return _get(res, 'data')
}